import http from '@/api/http'
import { safeGetSessionStorage } from './backendUtils'

// 商品圖片通行證：後端要求商品圖片網址附上 it 參數；後台每個分頁各自登入，通行證跟著分頁的登入令牌
const STORAGE_KEY = 'admin_product_image_token'
const REFRESH_BEFORE_MS = 60 * 60 * 1000

let current = null
let pending = null

const ownerKey = () => {
  const authToken = safeGetSessionStorage('admin_token')
  return authToken ? authToken.slice(-16) : ''
}

const readStored = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null')
  } catch {
    return null
  }
}

const usable = (entry, minRemainingMs = 0) => !!entry
  && entry.owner === ownerKey()
  && entry.expiresAt - Date.now() > minRemainingMs

export function getProductImageToken() {
  if (!usable(current)) current = readStored()
  return usable(current) ? current.token : null
}

export function ensureProductImageToken() {
  const owner = ownerKey()
  if (!owner) return Promise.resolve(null)
  if (!usable(current)) current = readStored()
  if (usable(current, REFRESH_BEFORE_MS)) return Promise.resolve(current.token)
  if (pending) return pending

  pending = http.get('/api/products/image-token')
    .then((response) => {
      current = { ...response.data.data, owner }
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(current))
      return current.token
    })
    .catch(() => null)
    .finally(() => {
      pending = null
    })
  return pending
}

export function appendProductImageToken(url) {
  if (!url || !url.includes('/uploads/products/')) return url
  const token = getProductImageToken()
  if (!token) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}it=${encodeURIComponent(token)}`
}
